var Notice = /** @class */ (function () {
    function Notice() {
        this.element = document.createElement('div');
        this.element.classList.add('notice');
        this.dismissible = false;
    }
    Notice.prototype.setMessage = function (message) {
        this.message = message;
        return this;
    };
    Notice.prototype.renderDismiss = function () {
        var _this = this;
        var button = document.createElement('button');
        button.classList.add('notice-dismiss');
        button.setAttribute('type', 'button');
        button.insertAdjacentHTML('beforeend', "<span class=\"screen-reader-text\">Dismiss this notice.</span>");
        button.addEventListener('click', function (e) {
            e.preventDefault();
            _this.element.remove();
        });
        this.element.classList.add('is-dismissible');
        this.element.insertAdjacentElement('beforeend', button);
    };
    Notice.prototype.renderContent = function () {
        this.element.insertAdjacentHTML('afterbegin', this.message);
    };
    Notice.prototype.makeDismissable = function () {
        this.dismissible = true;
        return this;
    };
    Notice.prototype.addClass = function (className) {
        this.element.classList.add(className);
        return this;
    };
    Notice.prototype.render = function () {
        this.element.innerHTML = '';
        this.renderContent();
        if (this.dismissible) {
            this.renderDismiss();
        }
        return this.element;
    };
    return Notice;
}());
export default Notice;
